module.exports = __webpack_public_path__ + "img/logo1.164d135a.png";